import React from 'react';
import { bool, func, string, array, number } from 'prop-types';
import { logger } from '@fiverr-private/obs';
import { LazyComponent } from '@fiverr-private/orca';
import sellerType from '../../../utils/types/seller';

const LazyModal = ({ projectList, projectId, origin, seller, selectProject, isMTEnabled, isContactEnabled, gigId, infinityPaging, overlayClassName }) => {
    const modalProps = {
        projectList,
        selectProject,
        projectId,
        origin,
        seller,
        isContactEnabled,
        isMTEnabled,
        gigId,
        infinityPaging,
        overlayClassName
    };

    const lazyOnError = (error) => logger.error(error, { description: 'Failed to lazy load PortfolioModal' });
    const lazyImport = () => import(
        /* webpackChunkName: 'PresenceModal' */ '.'
        );

    return (
        <LazyComponent lazyImport={lazyImport}
            shouldImport={!!projectId}
            componentProps={modalProps}
            onError={lazyOnError}/>
    );
};

LazyModal.propTypes = {
    projectList: array.isRequired,
    seller: sellerType,
    origin: string,
    projectId: string,
    selectProject: func,
    isMTEnabled: bool,
    isContactEnabled: bool,
    gigId: number,
    infinityPaging: bool,
    overlayClassName: string
};

export default LazyModal;
